import { PropsWithChildren } from 'react'

type RootProps = {}

export const Root = ({ children }: PropsWithChildren<RootProps>) => {
  return <div className="flex flex-col px-6 p-2">{children}</div>
}
